import { useV2GetServiceByIdQuery } from "@generated";

// Subservices (= subtasks) of a selected service; skipped when no serviceId.
export const useServiceSubservices = (serviceId: string | null) => {
  const { data } = useV2GetServiceByIdQuery(
    { id: serviceId ?? "", include: ["subservices"] } as any,
    { skip: !serviceId, refetchOnMountOrArgChange: true }
  );
  const included = (data as any)?.included ?? [];
  const subservices = included
    .filter((i: any) => i.type === "subservices")
    .map((i: any) => ({ id: String(i.id), name: i.attributes?.name ?? "" }));
  return { subservices };
};

export default useServiceSubservices;
